import React from "react";
import { Flex, GridItem, Text } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Checkbox, TextInput } from "components";
import { FormValues } from "../../duck";

const BoneAugmentation: React.FC = () => {
  const { watch, setValue } = useFormContext<FormValues>();
  const boneAugmentationValue = watch("boneAugmentation");

  return (
    <GridItem>
      <Text fontWeight="semibold" color="gray.600" mb={4}>
        Bone Augmentation
      </Text>

      <Flex align="center">
        <Checkbox
          isChecked={boneAugmentationValue}
          label={null}
          inputLayoutProps={{ w: "auto" }}
          onChange={event => {
            const { checked } = event.target;
            setValue("boneAugmentation", checked);
            if (!checked) {
              setValue("boneAugmentationDetails", null);
            }
          }}
        />
        <TextInput
          name="boneAugmentationDetails"
          label="Bone Augmentation"
          labelHidden
          isDisabled={!boneAugmentationValue}
        />
      </Flex>
    </GridItem>
  );
};

export default BoneAugmentation;
